import DefaultLayout from '@/views/layouts/Layout'

const Index = () => import('./Index')


export default [
    {
        path: '/',
        component: DefaultLayout,
        children: [
            {
                path: '/',
                alias: 'home',
                component: Index,
                name: 'home',
            },
        ]
    },
];
